(function() {
	'use strict';

	angular.module('smb-app')
		.directive('smbIndexTypeConfig', IndexTypeConfigDirective)
		.controller('smbIndexTypeConfigController', [
			'gettextCatalog',
			'sbToastService',
			'smbIndexTypesDataTypes',
			IndexTypeConfigController
		]);

	var templateUrl = require('./indexTypeConfig.template');
	function IndexTypeConfigDirective() {
		return {
			restrict: 'E',
			controller: 'smbIndexTypeConfigController',
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {
				currentIndexTypes: '=',
				currentIndexTypesTitle: '@',
				indexTypesPool: '=',
				indexTypesPoolTitle: '@',
				indexTypesPoolAddLabel: '@',
				allowEditName: '=',
				allowEditDefaultValue: '=',
				allowDelete: '=',
				onNewItem: '&',
				onEditItem: '&',
				onDelete: '&',
				enableSequencing: '=',
				onSequence: '&'
			}
		};
	}

	function IndexTypeConfigController(gettextCatalog, sbToastService, smbIndexTypesDataTypes) {
		var vm = this;
		vm.active = -1;
		vm.newIndexType = {
			name: '',
			dataType: {val: -1},
			defaultValue: ''
		};

		vm.smbIndexTypeDataTypes = smbIndexTypesDataTypes;
		vm.currentIndexTypes = vm.currentIndexTypes || [];
		vm.indexTypesPool = vm.indexTypesPool || [];

		vm.currentIndexTypesTitle = vm.currentIndexTypesTitle || gettextCatalog.getString('Curent Index Types');

		vm.dataTypes = [
			{
				label: smbIndexTypesDataTypes[smbIndexTypesDataTypes.STRING],
				val: smbIndexTypesDataTypes.STRING
			},
			{
				label: smbIndexTypesDataTypes[smbIndexTypesDataTypes.NUMERIC],
				val: smbIndexTypesDataTypes.NUMERIC
			},
			{
				label: smbIndexTypesDataTypes[smbIndexTypesDataTypes.DATE],
				val: smbIndexTypesDataTypes.DATE
			}
		];

		vm.setActive = setActive;
		vm.saveEdit = saveEdit;
		vm.cancelEdit = cancelEdit;
		vm.addIndexType = addIndexType;
		vm.addFromPool = addFromPool;
		vm.remove = remove;
		vm.swapIndexTypesOrder = swapIndexTypesOrder;

		Object.defineProperty(vm, 'allowEdit', {
			configurable: false,
			enumerable: true,
			get: function() { return vm.allowEditName || vm.allowEditDefaultValue; }
		});

		var activeEdit = null;

		function setActive(index) {
			vm.active = index;
			activeEdit = copyIndexType(vm.currentIndexTypes[vm.active]);
		}

		function saveEdit() {
			var target = vm.currentIndexTypes[vm.active];
			if (!indexTypeConflict(target)) {
				vm.onEditItem({item: target});
				vm.active = -1;
				activeEdit = null;
			} else {
				indexTypeConflictMessage(target.TagTypeName);
			}
		}

		function cancelEdit() {
			vm.currentIndexTypes[vm.active] = activeEdit;
			vm.active = -1;
			activeEdit = null;
		}

		function copyIndexType(indexType) {
			return Object.assign({}, indexType, {
				Constraints: Object.assign({}, indexType.Constraints),
				Links: Object.assign({}, indexType.Links)
			});
		}

		function addIndexType() {
			if (vm.newIndexType && vm.newIndexType.name && vm.newIndexType.dataType && vm.smbIndexTypeDataTypes[vm.newIndexType.dataType.val]) {
				var newIndexType = {
					TagTypeName: vm.newIndexType.name,
					DataType: vm.newIndexType.dataType.val,
					DataTypeName: vm.smbIndexTypeDataTypes[vm.newIndexType.dataType.val],
					Constraints: {},
					Links: {}
				};
				if (vm.newIndexType.defaultValue) {
					newIndexType.Constraints.DefaultValue = vm.newIndexType.defaultValue;
				}
				if (!indexTypeConflict(newIndexType)) {
					vm.onNewItem({item: newIndexType});
					vm.newIndexType.name = '';
					vm.newIndexType.dataType = {val: -1};
					vm.newIndexType.defaultValue = '';
				} else {
					indexTypeConflictMessage(newIndexType.TagTypeName);
				}
			}
		}

		function addFromPool(index) {
			vm.onNewItem({item: vm.indexTypesPool[index]});
		}

		function remove(index) {
			vm.onDelete({item: vm.currentIndexTypes[index]});
		}

		function indexTypeConflict(indexType) {
			var it = vm.currentIndexTypes.find(function(tt) {
				return tt.TagTypeName.toLowerCase() === indexType.TagTypeName.toLowerCase() && tt.TagTypeId !== indexType.TagTypeId;
			});

			if (!it && vm.indexTypesPool) {
				it = vm.indexTypesPool.find(function(tt) {
					return tt.TagTypeName.toLowerCase() === indexType.TagTypeName.toLowerCase() && tt.TagTypeId !== indexType.TagTypeId;
				});
			}

			return it ? true : false;
		}

		function indexTypeConflictMessage(indexTypeName) {
			var message = gettextCatalog.getString('"{{indexTypeName}}" index type already exists!', { indexTypeName: indexTypeName });
			sbToastService.showSimple(message);
		}

		function swapIndexTypesOrder(index1, index2) {
			if (vm.enableSequencing) {
				vm.onSequence({index1: index1, index2: index2});
			}
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/indexTypeConfig/indexTypeConfig.js
// module id = 90
// module chunks = 1